type JsonLDValue = Record<string, unknown>;

interface JsonLDProps {
  data: JsonLDValue;
}

export default function JsonLD({ data }: JsonLDProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function BreadcrumbListLD({ items }: { items: { name: string; url: string }[] }) {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.name,
      item: item.url,
    })),
  };
  return <JsonLD data={data} />;
}

export function OrganizationLD() {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '桔子视频',
    url: 'https://juzivideo.com',
    description: '桔子视频提供西瓜视频免费在线观看服务，高清全集不缓冲，电视剧大全电影免费看。',
    logo: 'https://juzivideo.com/logo.png',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-9999',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
    sameAs: [
      'https://weibo.com/juzivideo',
      'https://www.douyin.com/user/juzivideo',
    ],
  };
  return <JsonLD data={data} />;
}

export function WebSiteLD() {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '桔子视频',
    url: 'https://juzivideo.com',
    description: '桔子视频提供西瓜视频免费在线观看服务，西瓜视频、丝瓜视频高清全集不缓冲，电视剧大全电影免费看。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://juzivideo.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };
  return <JsonLD data={data} />;
}

export function WebPageLD({ name, description, url }: { name: string; description: string; url: string }) {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name,
    description,
    url,
  };
  return <JsonLD data={data} />;
}

export function ArticleLD({ article }: { article: { title: string; description: string; url: string; datePublished: string; author: string; image: string } }) {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    url: article.url,
    datePublished: article.datePublished,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    image: article.image,
    publisher: {
      '@type': 'Organization',
      name: '桔子视频',
    },
  };
  return <JsonLD data={data} />;
}

export function FAQPageLD({ questions }: { questions: { question: string; answer: string }[] }) {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions.map((q) => ({
      '@type': 'Question',
      name: q.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: q.answer,
      },
    })),
  };
  return <JsonLD data={data} />;
}